const state = {
  addressId: '', // 支付地址
  payType: '', // 支付方式 cart 购物车结算 buyNow 立即购买结算
  payInfo: [], // 支付信息
  paymentType: {
    // 支付类型
    cart: 'cart',
    buyNow: 'buyNow'
  },
  // 福利卡信息
  welfareCard: {},
  orderId: '', // 订单号
  // 支付方式
  payWay: {
    saas: [], // saas支付方式 积分| 余额| 优惠劵
    cansh: [] // 现金支付方式 微信 | 支付宝 | 银联
  },
  address: {},
  addressInfo: {},
  cakeShop: {}, // 蛋糕门店
  cakeDelivery: ''
}

export default state
